export default [
  {
    path: '/products/locations',
    name: 'products-locations-index',
    component: () => import('@/views/product/locations/LocationList.vue'),
    meta: {
      title: 'Locations',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Locations',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'read',
    },
  },
  {
    path: '/products/locations/create',
    name: 'products-locations-create',
    component: () => import('@/views/product/locations/LocationCreate.vue'),
    meta: {
      title: 'Create New Location',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-locations-index',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/products/locations',
        },
        {
          text: 'Create New Location',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'create',
    },
  },
  {
    path: '/products/locations/:id/show',
    name: 'products-locations-show',
    component: () => import('@/views/product/locations/LocationDetails.vue'),
    meta: {
      title: 'Location Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-locations-index',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/products/locations',
        },
        {
          text: 'Location Detail',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'show',
    },
  },
  {
    path: '/products/locations/:id/update',
    name: 'products-locations-edit',
    component: () => import('@/views/product/locations/LocationEdit.vue'),
    meta: {
      title: 'Edit Location',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-locations-index',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/products/locations',
        },
        {
          text: 'Edit Location',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'update',
    },
  },
  {
    path: '/products/areas',
    name: 'products-areas-index',
    component: () => import('@/views/product/areas/AreaList.vue'),
    meta: {
      title: 'Areas',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Areas',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'read',
    },
  },
  {
    path: '/products/areas/create',
    name: 'products-areas-create',
    component: () => import('@/views/product/areas/AreaCreate.vue'),
    meta: {
      title: 'Create New Area',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-areas-index',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/products/areas',
        },
        {
          text: 'Create New Area',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'create',
    },
  },
  {
    path: '/products/areas/:id/show',
    name: 'products-areas-show',
    component: () => import('@/views/product/areas/AreaDetails.vue'),
    meta: {
      title: 'Area Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-areas-index',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/products/areas',
        },
        {
          text: 'Area Detail',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'show',
    },
  },
  {
    path: '/products/areas/:id/update',
    name: 'products-areas-edit',
    component: () => import('@/views/product/areas/AreaEdit.vue'),
    meta: {
      title: 'Edit Area',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-areas-index',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/products/areas',
        },
        {
          text: 'Edit Area',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'update',
    },
  },

  {
    path: '/products/suites',
    name: 'products-suites-index',
    component: () => import('@/views/product/suites/SuiteList.vue'),
    meta: {
      title: 'Suites',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'read',
    },
  },
  {
    path: '/products/suites/create',
    name: 'products-suites-create',
    component: () => import('@/views/product/suites/SuiteCreate.vue'),
    meta: {
      title: 'Create New Suite',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Create New Suite',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'create',
    },
  },
  {
    path: '/products/suites/:id/show',
    name: 'products-suites-show',
    component: () => import('@/views/product/suites/SuiteDetails.vue'),
    meta: {
      title: 'Suite Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Suite Detail',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'show',
    },
  },
  {
    path: '/products/suites/:id/update',
    name: 'products-suites-edit',
    component: () => import('@/views/product/suites/SuiteEdit.vue'),
    meta: {
      title: 'Edit Suite',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Edit Suite',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'update',
    },
  },
  {
    path: '/products/lots/:id/show',
    name: 'products-lots-show',
    component: () => import('@/views/product/lots/LotDetails.vue'),
    meta: {
      title: 'Lot Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Lot Detail',
          active: true,
        },
      ],
      resource: 'Lot',
      action: 'show',
    },
  },
]
